import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './ProgressBar.scss';

export default class ProgressBar extends PureComponent {
  static propTypes = {
    progress: PropTypes.number,
    classInner: PropTypes.string
  };

  render() {
    const { progress, classInner } = this.props;
    const classComponent = classNames('progress__bar__inner', classInner);

    return (
      <div className="progress__bar">
        <span
          className={classComponent}
          style={{ width: `${progress}%` }}
        ></span>
      </div>
    );
  }
}
